import { Questions } from "@types-runway/questionnaire";

const prefilledConsentKeys = ["pharmacyConsent", "telemedicineConsent"];

export const selectHasQuestionnaireAnswers = (questions: Questions): boolean =>
  Object.entries(questions)
    .filter(([stateKey]) => !prefilledConsentKeys.includes(stateKey))
    .some(([, { answer }]) => answer !== "" && answer !== null && answer !== undefined);
